import { Modal, Text } from "@shopify/polaris";
import useLocales from "../../../hooks/useLocales";

const AskReview = ({ open, onClose, setShowRatingModal, setShowWriteReview }) => {
  const { translate } = useLocales();

  const openWriteReview = () => {
    setShowWriteReview(true);
  };

  const openRatingModal = () => {
    setShowRatingModal(true);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={translate("page.dashboard.ask-feedback-modal-title")}
      primaryAction={{
        content: translate("page.dashboard.ask-feedback-modal-button-great"),
        onAction: openRatingModal,
      }}
      secondaryActions={[
        {
          content: translate("page.dashboard.ask-feedback-modal-button-problem"),
          onAction: openWriteReview,
        },
      ]}
    >
      <Modal.Section>
        <Text variant="bodyMd">{translate("page.dashboard.review-modal-body")}</Text>
      </Modal.Section>
    </Modal>
  );
};

export default AskReview;
